import { AppBar, css, Stack, Toolbar } from '@mui/material';
import { ReactNode } from 'react';

const styles = css({
    '& .container-buttons': {
        marginLeft: 20
    },
    '& .geopost-logo': {
    },
    '& svg': {
        color: '#fff',

        '&:hover': {
            color: '#444'
        }
    }
});

type Params = {
    showGeopostLogo?: boolean,
    title?: string,
    buttons?: ReactNode[]
};

export const GeopostAppBar = ({ showGeopostLogo = true, title, buttons }: Params) => {
    return (<AppBar position='static' css={styles}>
        <Toolbar>
            <Stack direction='row' justifyContent='space-between' alignItems='center' width='100%'>
                { showGeopostLogo && <img src="https://www.geopostenergy.com/Images/logo_mapa.png" className='geopost-logo'></img>}
                <Stack className='container-buttons' direction='row' flexGrow={1}>
                    { buttons }
                </Stack>
                { title && <span className='title'>{title}</span>}
            </Stack>
        </Toolbar>
    </AppBar>);
};